<div [formGroup]="formGroup">
  <sc-sub-title><sc-dictionary-label
      dictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.supplementary-equipment-title"></sc-dictionary-label></sc-sub-title>
  <sc-content-spacer vertical></sc-content-spacer>

  <ng-container *ngIf="direction === 'entrance'">

    <sc-no-data *ngIf="equipments == null || equipments.length == 0"></sc-no-data>

    <ng-container *ngIf="yardPropertiesService.isShowNoHandoutEnabled()">
      <sc-checkbox-field formControlName="noHandout"
        labelDictionaryKey="tmc.transport.register-entrance-combined.label.nosupplementaryequipmenthandout"></sc-checkbox-field>
    </ng-container>

    <ng-container *ngFor="let equipment of equipments">
      <sc-content-spacer vertical></sc-content-spacer>
      <app-supplementary-equipment-item [supplementaryEquipment]="equipment"
        (changed)="handleSupplementaryEquipmentChange($event)"></app-supplementary-equipment-item>
    </ng-container>

  </ng-container>

  <ng-container *ngIf="direction === 'leave'">
    <div *ngFor="let eq of outhandedEquipments">
      <app-outhanded-supplementary-equipment-item
        [supplementaryEquipment]="eq" (changed)="handleOuthandedChanged()"></app-outhanded-supplementary-equipment-item>
    </div>
  </ng-container>

</div>
